import { useGetFeeServicesQuery, FeeServicesFilter } from '@/pages/Fleet/Businesses/services/fee-services.service';

interface UseServicesProps {
  filters?: FeeServicesFilter;
  page: number;
  pageSize: number;
}

const useServices = ({ filters, page, pageSize }: UseServicesProps) => {
  const { data, isLoading, error } = useGetFeeServicesQuery({
    filters,
    paginated: { page, pageSize },
  });

  return {
    isLoading,
    error,
    services: data?.items || [],
    totalItems: data?.count || 0,
    totalPages: data?.count ? Math.ceil(data.count / pageSize) : 0,
  };
};

export default useServices;
